import React from 'react';

const LandlordHome = () => {
  return (
    <div>
      <h1>Welcome Landlord Home</h1>
      <p>Here’s a summary of your tenancy status:</p>

      <section>
        <h3>Pending Bills</h3>
        <ul>
          <li>Rent (October): £1,200 - Due: Oct 15, 2025</li>
          <li>Electricity: £45 - Due: Oct 10, 2025</li>
        </ul>
      </section>

      <section>
        <h3>In Progress Issues</h3>
        <ul>
          <li>Leaking kitchen tap - Reported: Oct 5, 2025</li>
          <li>Wi-Fi disruption - Reported: Oct 6, 2025</li>
        </ul>
      </section>
    </div>
  );
};

export default LandlordHome;
